import { filterConfig } from "./filter-config"

let categories: string[] = []

export function setCategories(newCategories: string[]) {
    categories = newCategories
}

export function addCategory(category: string) {
    if (!categories.includes(category)) categories.push(category)
}

export function getCategories() {
    return categories
}

export function getCategoriesAsString() {
    return categories.join(filterConfig.delimiterValues)
}

export function removeCategory(removeCategory: string) {
    categories = categories.filter((category) => category !== removeCategory)
}

export function parseCategoriesFromLocation() {
    const pathSplit = location.pathname.split("/")
    const sexAnzeigenKeyIndex = pathSplit.findIndex((path) => path.includes("sex-anzeigen"))
    const maybeCategoryString = pathSplit[sexAnzeigenKeyIndex + 1]
    if (maybeCategoryString && !maybeCategoryString.includes(filterConfig.delimiterGroupValue)) {
        categories = maybeCategoryString.split(filterConfig.delimiterValues)
    } else {
        categories = []
    }
}

parseCategoriesFromLocation()
